import { DISCARD, RELOAD_STATE, SAVE_SETTINGS, VALIDATE } from '../common/actions';

import { calcInvalidTabs, validateAll, validateCrossFields } from '../common/utils';

export const useSaveSettings = (
    saveFunc,
    settings,
    mapToSettings,
    fields,
    selectedTab,
    dispatch,
    discardExtra = {},
    ignoredFields = {},
    includeFullError
) => {
    const saveSettings = async (saveAll, tab = selectedTab) => {
        const validatedFields = validateAll(fields, ignoredFields);
        const invalidTabs = calcInvalidTabs(validatedFields);
        if (invalidTabs.length > 0 && (saveAll || invalidTabs.includes(tab))) {
            dispatch({ type: VALIDATE, payload: { saveAll, selectedTab: tab, ignoredFields } });
            return Promise.reject('Validation Failed!');
        }
        const validatedCrossFields = validateCrossFields(validatedFields, tab);
        const invalidCrossTabs = calcInvalidTabs(validatedCrossFields);
        if (invalidCrossTabs.length > 0 && (saveAll || invalidCrossTabs.includes(tab))) {
            dispatch({ type: VALIDATE, payload: { saveAll, selectedTab: tab, ignoredFields } });
            return Promise.reject('Validation Failed!');
        }

        const newSettings = mapToSettings(saveAll, tab, fields, settings);
        const savedSettings = await saveFunc(newSettings, null, includeFullError);
        dispatch({ type: SAVE_SETTINGS, payload: { saveAll, selectedTab: tab } });
        return savedSettings;
    };

    const discardSettings = (discardAll) => {
        if (discardAll) {
            dispatch({ type: RELOAD_STATE, payload: { settings, discardExtra } });
        } else {
            dispatch({ type: DISCARD, payload: { settings, fields, selectedTab, discardExtra } });
        }
    };

    return [saveSettings, discardSettings];
};
